import FullWidthLayout from "@/layouts/FullWidthLayout";
import KEmployeeInjuryReportsTable from "kinnect-front/KSafety/Injuries/KEmployeeInjuryReportsTable";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { SafetyEmployeeInjuryReport } from "kinnect-models";
import { VCard, VSheet } from "vuetify/lib";
import { debounce } from "kinnect-helpers";

export default {
	name: "SafetyEmployeeInjuryReportsPage",

	metaInfo: { title: "Safety - Employee Injury Reports" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		reports: [],
		search: "",
		searchReports: []
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "add_safety_employee_injury_reports" ) ) {
				return {
					icon: "add_circle",
					text: "File Injury Report",
					to: { name: "safetyEmployeeInjuryAdd" },
					tooltip: "File a new employee injury report"
				};
			}
		},

		numReports() {
			return this.reports.length;
		},

		displayedReports() {
			if ( this.search ) {
				return this.searchReports;
			}

			return this.reports;
		}
	},

	watch: {
		numReports( numReports ) {
			this.$store.dispatch( "breadcrumbs/setDetails", `${numReports} reports` );
		},

		search() {
			this.fetchSearchResults();
		}
	},

	methods: {
		fetchSearchResults: debounce( async function() {
			if ( this.search ) {
				const queryWhenCallStarted = this.search;

				const reports = await SafetyEmployeeInjuryReport
				.custom( "safety/employee-injury-reports/search" )
				.params( { query: queryWhenCallStarted } )
				.get();

				if ( this.search === queryWhenCallStarted ) {
					this.searchReports = reports;
				}
			} else {
				this.searchReports = [];
			}
		}, 500 ),

		async fetchReports() {
			this.reports = await SafetyEmployeeInjuryReport
			.select( {
				employee: [ "id", "firstName", "lastName" ],
				supervisor: [ "id", "firstName", "lastName" ],
				"safety_employee_injury_reports": [
					"created_at",
					"id",
					"idUserEmployee",
					"idUserSupervisor",
					"injuryDate",
					"injuryLocation",
					"injuryTime"
				]
			} )
			.include( [
				"employee",
				"supervisor"
			] )
			.get();
		},

		async fetch() {
			await this.fetchReports();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<KEmployeeInjuryReportsTable
					items={this.displayedReports}
					loading={this.$wait.is( "get employee injury reports" )}
					search={this.search}
				></KEmployeeInjuryReportsTable>
			</VCard>
		</FullWidthLayout>;
	}
};
